import React from 'react';
import PropTypes from 'prop-types';

const OnboardingFooterContext = React.createContext(undefined);

function OnboardingFooterProvider({ children }) {
  const footerRef = React.useRef();
  const [value] = React.useState({ footerRef });

  return (
    <OnboardingFooterContext.Provider value={value}>
      {children}
    </OnboardingFooterContext.Provider>
  );
}

function useOnboardingFooter() {
  const context = React.useContext(OnboardingFooterContext);

  if (context === undefined) {
    throw new Error('useOnboardingFooter must be used within a OnboardingFooterProvider');
  }

  return context;
}

OnboardingFooterProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
};

export {
  OnboardingFooterProvider,
  useOnboardingFooter,
};
